<template>
	<div class="welcome">
		<v-snackbar v-model="snackbar" :timeout="4000" bottom right :color="color">
			<span>{{ message }}</span>
		</v-snackbar>
		<v-layout column>
			<v-flex xs12>
				<v-img dark height="250" src="img/cover_photo.png">
					<div align="center" class="font-weight-black mt-16">
						<h1>Women in Tech Accelerator</h1>
					</div>
					<div align="center" class="mt-2">
						SCWomenInTech
					</div>
				</v-img>
			</v-flex>
			<v-flex xs12 class="white">
				<v-container>
					<div class="my-16">
                        <div align="center" class="font-weight-black mb-12">
                            <h1>Expression of Interest - Cohort 9</h1>
                        </div>

                        <div v-if="formData == null">
                            <v-card outlined class="mx-auto my-16" elevation="0" style="border-radius: 25px;">
                                <v-container style="height: 400px;">
                                    <v-row class="fill-height" align-content="center" justify="center">
                                        <v-col class="text-subtitle-1 text-center" cols="12">
                                            Getting ready..
                                        </v-col>
                                        <v-col cols="6">
                                            <v-progress-linear color="primary" indeterminate rounded height="6"></v-progress-linear>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card>
                        </div>
                        <div v-else>
                            <v-stepper v-model="e1" outlined style="border-radius: 25px;">
                                <v-stepper-header>
                                    <v-stepper-step :complete="e1 > 1" step="1">
                                        Introduction
                                    </v-stepper-step>

                                    <v-divider></v-divider>
                                    
                                    <v-stepper-step :complete="e1 > 2" step="2">
                                        Personal & Venture Details
                                    </v-stepper-step>

                                    <v-divider></v-divider>

                                    <v-stepper-step :complete="e1 > 3" step="3">
                                        Confirmation
                                    </v-stepper-step>
                                </v-stepper-header>

                                <v-stepper-items>
                                    <v-stepper-content step="1">
                                        <div align="center" class="mt-5">
                                                <v-layout row wrap>
                                                    <v-flex xs12>
                                                        <div align="center" class="mt-2">
                                                            <v-img max-width="250" src="img/sc_foundation.png"> </v-img>
                                                        </div>                      
                                                        </v-flex>
                                                        <v-flex xs6>
                                                            <div align="right" class="mt-2 mt-md-4 mx-2">
                                                            <v-img max-width="290" src="img/VillCap.png"> </v-img>
                                                        </div>
                                                        </v-flex>
                                                        <v-flex xs6>
                                                            <div align="left" class="mx-2">
                                                            <v-img max-width="290" src="img/ibiz-logo-new.png"> </v-img>
                                                        </div>
                                                        </v-flex>
                                                </v-layout>														
                                            </div>
                                        <v-layout column>
                                            <v-flex xs12>
                                                <div class="mx-2 mt-10" align="center">
                                                    <div class="mt-5">
                                                        Thank you for your interest in the Standard Chartered Women in Tech Accelerator.
                                                    </div>
                                                    <div class="mb-5">
                                                        This Expression of Interest (EOI) allows us to examine your eligibility as a Founder ahead of the official application launch
                                                    </div>
                                                </div>
                                            </v-flex>
                                            <!-- <v-flex xs12>
                                                <div class="mx-2 mt-5" align="center">
                                                    <div class="text-subtitle-1 font-weight-bold mb-1">
                                                        Please note:
                                                    </div>
                                                    <div>
                                                        ⚠️ This is NOT the official application form.
                                                    </div>
                                                    <div>
                                                        Submitting this form does not constitute an application or guarantee selection.
                                                    </div>
                                                </div>
                                            </v-flex> -->
                                            <v-flex xs12>
                                                <div class="my-5 mx-16">
                                                    <v-divider></v-divider>
                                                </div>
                                            </v-flex>
                                            <v-flex xs12>
                                                <div class="mx-2" align="center">
                                                    <v-btn depressed class="primary text-none mb-3 mt-1" @click="e1 = 2">
                                                        Proceed to Expression of Interest Form <v-icon right dark>mdi-chevron-right</v-icon>
                                                    </v-btn>
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                    </v-stepper-content>
                                    <v-stepper-content step="2">                                    
                                        <v-layout column>
                                            <v-flex xs12>
                                                <div>
                                                    <h2>Personal Details</h2>
                                                </div>
                                                <div class="mx-2">                                                    
                                                    <v-form ref="profileForm" v-model="personalValid" lazy-validation>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 md4>
                                                                <div class="mx-1 mt-5">
                                                                    <div>First Name<span class="red--text">*</span>
                                                                    </div>
                                                                    <v-text-field outlined dense v-model="newExpression.first_name" :rules="inputRules"
                                                                        class="text_field background" prepend-inner-icon="mdi-account"></v-text-field>
                                                                    <div class="font-italic"><h6>First Name as per your National ID or Passport</h6></div>
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12 md4>
                                                                <div class="mx-1 mt-5">
                                                                    <div>Middle Name</div>
                                                                    <v-text-field outlined dense v-model="newExpression.middle_name"
                                                                        class="text_field background" prepend-inner-icon="mdi-account"></v-text-field>
                                                                    <div class="font-italic"><h6>Middle Name as per your National ID or Passport</h6></div>
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12 md4>
                                                                <div class="mx-1 mt-5">
                                                                    <div>Last Name<span class="red--text">*</span></div>
                                                                    <v-text-field outlined dense v-model="newExpression.last_name" :rules="inputRules"
                                                                        class="text_field background" prepend-inner-icon="mdi-account"></v-text-field>
                                                                    <div class="font-italic"><h6>Last Name as per your National ID or Passport</h6></div>
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12 md4>
                                                                <div class="mx-1 mt-5">
                                                                    <div>Email<span class="red--text">*</span></div>
                                                                    <v-text-field outlined dense v-model="newExpression.email" :rules="emailRules"
                                                                        class="text_field background"
                                                                        prepend-inner-icon="mdi-email"></v-text-field>
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12 md4>
                                                                <div class="mx-1 mt-5">
                                                                    <div>Phone Number<span class="red--text">*</span>
                                                                    </div>
                                                                    <v-text-field outlined dense v-model="newExpression.phone" :rules="inputRules"
                                                                        class="text_field background" prepend-inner-icon="mdi-phone"></v-text-field>
                                                                    <div class="font-italic"> 
                                                                        <h6>Please give a number we can easily reach you directly. Mobile Number Preferred</h6>
                                                                    </div>
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12 md4>
                                                                <div class="mx-1 mt-5">
                                                                    <div>Age<span class="red--text">*</span></div>
                                                                    <v-select :items="formData.ageGroups" item-text="name" item-value="id"
                                                                        v-model="newExpression.age_group_id" :rules="inputRules" class="text_field background" dense
                                                                        outlined prepend-inner-icon="mdi-calendar">
                                                                    </v-select>
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12 md4>
                                                                <div class="mx-1 mt-5">
                                                                    Do you identify as a person with Disability?<span class="red--text">*</span>
                                                                </div>
                                                                <div class="mx-1">                                                                    
                                                                    <v-select :items="pwds" item-text="name" item-value="id"
                                                                        v-model="newExpression.pwd" :rules="inputRules" class="text_field background" dense
                                                                        outlined prepend-inner-icon="mdi-human">
                                                                    </v-select>
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12 md4>
                                                                <div class="mx-1 mt-5">
                                                                    <div>Nationality<span class="red--text">*</span></div>
                                                                    <v-select :items="formData.countries" item-text="name" item-value="id"
                                                                        v-model="newExpression.country_id" :rules="inputRules" class="text_field background" dense
                                                                        outlined prepend-inner-icon="mdi-flag">
                                                                    </v-select>
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12 md4>
                                                                <div class="mx-1 mt-5">
                                                                    <div>City/Town of Residence<span class="red--text">*</span></div>
                                                                    <v-select :items="formData.cities" item-text="name" item-value="id"
                                                                        v-model="newExpression.city_id" :rules="inputRules" class="text_field background" dense
                                                                        outlined prepend-inner-icon="mdi-city">
                                                                    </v-select>
                                                                </div>
                                                            </v-flex>

                                                            <v-flex xs12>
                                                                <div class="mt-10 mb-5 mx-16">
                                                                    <v-divider></v-divider>
                                                                </div>
                                                            </v-flex>

                                                            <v-flex xs12>
                                                                <div class="mx-1 mt-2">
                                                                    <h2>Venture Details</h2>
                                                                </div>
                                                            </v-flex>
                                                            
                                                            <v-flex xs12 md6>
                                                                <div class="mx-1 mt-5">
                                                                    <div>Startup Name<span class="red--text">*</span></div>
                                                                    <v-text-field outlined dense v-model="newExpression.name" :rules="inputRules"
                                                                        class="text_field background" prepend-inner-icon="mdi-briefcase"></v-text-field>
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12 md3>
                                                                <div class="mx-1 mt-5">
                                                                    <div>Country of Operation<span class="red--text">*</span></div>
                                                                    <v-select :items="formData.countries" item-text="name" item-value="id"
                                                                        v-model="newExpression.operation_country_id" :rules="inputRules" class="text_field background" dense
                                                                        outlined prepend-inner-icon="mdi-map">
                                                                    </v-select>
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12 md3>
                                                                <div class="mx-1 mt-5">
                                                                    <div>Year Established<span class="red--text">*</span></div>
                                                                    <v-select :items="years" outlined dense v-model="newExpression.year_established" :rules="inputRules"
                                                                        prepend-inner-icon="mdi-calendar" class="background login_field"></v-select>
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12>
                                                                <div class="mx-1 mt-5" v-if="formData != null">
                                                                    <div>Sector(s)<span class="red--text">*</span></div>
                                                                    <v-select v-model="newExpression.sectors" :items="formData.sectors" chips item-value="id"
                                                                        item-text="name" multiple outlined class="chip_text_field background"
                                                                        :rules="inputRules"></v-select>
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12>
                                                                <div class="mx-1 mt-5">
                                                                    <div>Briefly describe your solution<span class="red--text">*</span></div>
                                                                    <div class="black--text">
                                                                        <ckeditor :editor="editor" v-model="newExpression.description" :config="editorConfig"
                                                                            :rules="inputRules">
                                                                        </ckeditor>
                                                                    </div>
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12>
                                                                <div class="mx-1 mt-5" v-if="formData != null">
                                                                    <div>What best decribes the stage of development of your product or service<span class="red--text">*</span></div>
                                                                    <v-radio-group v-model="newExpression.stage_id" row>
                                                                        <template v-for="(
                                                                                option, index
                                                                                ) in formData.stages">
                                                                            <div :key="index">
                                                                                <v-radio :label="option.name" :value="option.id"></v-radio>
                                                                            </div>
                                                                        </template>
                                                                    </v-radio-group>
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12 md4>
                                                                <div class="mx-1 mt-5">
                                                                    <div>Annual revenue generated in 2025 in KES<span class="red--text">*</span></div>
                                                                    <v-select :items="formData.revenueRanges" item-text="name" item-value="id"
                                                                        v-model="newExpression.revenue_range_id" :rules="inputRules" class="text_field background" dense
                                                                        outlined prepend-inner-icon="mdi-cash-multiple">
                                                                    </v-select>
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12 md4>
                                                                <div class="mx-1 mt-5">
                                                                    <div>Number of startup team members<span class="red--text">*</span></div>
                                                                    <v-select :items="formData.teamMembers" item-text="name" item-value="id"
                                                                        v-model="newExpression.team_member_id" :rules="inputRules" class="text_field background" dense
                                                                        outlined prepend-inner-icon="mdi-account-group">
                                                                    </v-select>
                                                                </div>
                                                            </v-flex>
                                                            
                                                            <v-flex xs12>
                                                                <div class="my-5 mx-16">
                                                                    <v-divider></v-divider>
                                                                </div>
                                                            </v-flex>
                                                            
                                                        </v-layout>
                                                    </v-form>
                                                </div>
                                            </v-flex>                                                
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex xs6>
                                                    <div align="left">
                                                        <v-btn depressed class="red text-none white--text ml-4 mb-3 mt-4" @click="e1 = 1">
                                                            <v-icon left dark class="white--text">mdi-chevron-left</v-icon> Back
                                                        </v-btn>
                                                    </div>
                                                </v-flex>
                                                <v-flex xs6>
                                                    <div align="right">
                                                        <v-btn depressed class="primary text-none mr-4 mb-3 mt-4" @click="saveEOI()"
                                                            :loading="loading" :disabled="!personalValid">
                                                            Save and Continue <v-icon right dark>mdi-chevron-right</v-icon>
                                                        </v-btn>
                                                    </div>
                                                </v-flex>
                                        </v-layout>

                                    </v-stepper-content>
                                    <v-stepper-content step="3">
                                        <v-layout column>
                                            <v-flex xs12>
                                                <div class="mx-2 mt-5">                                                    
                                                        <v-row class="fill-height" align-content="center" justify="center">
                                                            <v-col cols="12">
                                                                <div align="center">
                                                                    <v-icon size="150px" class="green--text">
                                                                        mdi-check-circle
                                                                    </v-icon>
                                                                </div>
                                                            </v-col>
                                                            <v-col class="text-subtitle-1 text-center" cols="12">
                                                                Your expression of interest has been successfully submitted.
                                                            </v-col>
                                                            <!-- <v-col class="caption text-center" cols="12">
                                                                You have the option to make modifications up until the deadline day.
                                                            </v-col> -->
                                                            
                                                                <v-checkbox 
                                                                    v-model="newExpression.create_account"
                                                                    label="Create an account">
                                                                </v-checkbox>                                                                
                                                                <v-col class="text-subtitle-1" cols="12">
                                                                    <div v-if="newExpression.create_account">
                                                                        <v-form ref="form" v-model="valid" lazy-validation>
                                                                            <v-layout row wrap>
                                                                                <v-flex xs12 md6>
                                                                                    <div class="mx-1">
                                                                                        <div><b>Password</b>
                                                                                            <span class="red--text">*</span></div>
                                                                                        <v-text-field outlined dense v-model="newExpression.password" :rules="passwordRules"
                                                                                            type="password" prepend-inner-icon="mdi-lock-outline" class="background login_field"></v-text-field>
                                                                                    </div>
                                                                                </v-flex>
                                                                                <v-flex xs12 md6>
                                                                                    <div class="mx-1">
                                                                                        <div><b>Confirm Password</b><span class="red--text">*</span></div>
                                                                                        <v-text-field outlined dense 
                                                                                            v-model="confirmpassword" 
                                                                                            :rules="passwordConfirmRules"
                                                                                            type="password" 
                                                                                            prepend-inner-icon="mdi-lock-outline"
                                                                                            class="background login_field">
                                                                                        </v-text-field>
                                                                                    </div>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                        </v-form>
                                                                    </div>
                                                                </v-col>
                                                        </v-row>                                                    
                                                </div>
                                            </v-flex>
                                            <v-flex xs12>
                                                <div class="my-10 mx-16">
                                                    <v-divider></v-divider>
                                                </div>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-layout row wrap class="mb-3">
                                                    <v-flex xs6>
                                                        <div align="left">
                                                            <v-btn depressed class="red text-none white--text ml-3" @click="e1 = 2">
                                                                <v-icon left dark class="white--text">mdi-chevron-left</v-icon> Back
                                                            </v-btn>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs6>
                                                        <div align="right" v-if="newExpression.create_account">
                                                            <v-btn 
                                                                depressed 
                                                                class="primary text-none mr-3" 
                                                                @click="create()" 
                                                                :loading="loading"
                                                                :disabled="!valid">
                                                                Create Account <v-icon right dark>mdi-account-box-plus-outline</v-icon>
                                                            </v-btn>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>

                                            </v-flex>
                                        </v-layout>
                                    </v-stepper-content>
                                    <v-stepper-content step="4">
                                        <v-layout column>
                                            <v-flex xs12>
                                                <div class="mx-2 mt-5">                                                    
                                                    <v-row class="fill-height" align-content="center" justify="center">
                                                        <v-col cols="12">
                                                            <div align="center">
                                                                <v-icon size="150px" class="green--text">
                                                                    mdi-account-check
                                                                </v-icon>
                                                            </div>
                                                        </v-col>
                                                        <v-col class="text-subtitle-1 text-center" cols="12">
                                                            Account Created. We've sent you an activation link via email.
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                    </v-stepper-content>
                                </v-stepper-items>
                            </v-stepper>
                        </div>						
					</div>
				</v-container>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import Vue from "vue";
import apiCall from "@/utils/api";
import { mapState, mapGetters, mapActions } from "vuex";
import { USER_REQUEST } from "@/store/actions/user";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import uploadAdapter from '@/uploadAdapter.js';
import pdf from 'vue-pdf'

export default {
	components: {
		pdf
	},
	data() {
		return {
			path: process.env.VUE_APP_API_URL,

			editor: ClassicEditor,
			editorConfig: {
				extraPlugins: [function (editor) {
					editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
						return new uploadAdapter(loader);
					}
				}],
				language: 'en',
			},

			color           : "",
			delete          : false,
			loading         : false,
			valid           : true,
			personalValid   : true,
			termsValid      : true,
			message         : "",
			snackbar        : false,
			confirm         : false,
			years           : [],

            pwds: [
                {id: 1, name: 'Yes'},
                {id: 2, name: 'No'}
            ],


			formData: null,

			inputRules: [(v) => !!v || "Input is required"],
			emailRules: [
				(v) => !!v || "Input is required",
				(v) =>
					!v ||
					/^[a-zA-Z0-9\.!#$%&'*+/=?^_~-]+@([a-zA-Z0-9]+\.)+[a-zA-Z]{2,3}$/.test(
						v
					) ||
					"E-mail must be valid",
				(v) => !v || (v && v.length <= 50) || "Maximum 50 characters",
			],

			completeApplication: false,

			e1: 1,

			newExpression: {
				id			        : null,
                user_id             : null,
				first_name	        : null,
				middle_name	        : null,
				last_name	        : null,
                age_group_id        : null,
				email		        : null,
				phone		        : null,
				country_id          : null,
                city_id             : null,
                pwd                 : null,
                startup_name        : null,
                operation_country_id: null,
                year_established    : null,
                description		    : null,
                stage_id	        : null,
                team_member_id      : null,
                revenue_range_id    : null,
                sectors			    : [],
                create_account      : false
			},

            confirmpassword: "",
            passwordConfirmRules: [(v) => !!v || " "],
            passwordRules: [
            (v) => !!v || "Password is required",
            (v) => (v && v.length >= 8) || "Minimum 8 characters",
            (v) =>
                /(?=.*[A-Z])/.test(v) || "Must have at least one uppercase character",
            (v) => /(?=.*\d)/.test(v) || "Must have at least one number",
            (v) =>
                /([!@#$%.])/.test(v) ||
                "Must have at least one special character [!@#$%.]",
            ],
		};
	},
	mounted() {
		window.onscroll = () => {
			this.changeColor();
		};
	},
	created() {
		window.scrollTo(0, 0);
		this.changeHeaderColor("#144835");
		this.changeTitleColor("red--text");
		this.changeButtonColor("red--text hidden-sm-and-down text-none caption");

        this.populateYears();
        this.getFormData()
	},
	methods: {
		...mapActions([
			"changeHeaderColor",
			"changeTitleColor",
			"changeButtonColor"
		]),
		changeColor() {
			if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
				this.changeHeaderColor("white");
				this.changeTitleColor("black--text");
				this.changeButtonColor("black--text hidden-sm-and-down text-none caption");
			} else {
				this.changeHeaderColor("white");
				this.changeTitleColor("white--text");
				this.changeButtonColor("white--text hidden-sm-and-down text-none caption");
			}
		},
        populateYears() {
			var max = new Date().getFullYear();
			var min = max - 100;
			var years = [];

			for (var i = max; i >= min; i--) {
				years.push(i);
			}
			this.years = years;
		},

        create() {
            if (this.$refs.form.validate()) {
                if (this.newExpression.password != this.confirmpassword) {
                    this.message    = "Passwords do not match";
                    this.color      = "error";
                    this.snackbar   = true;
                } else {
                    this.loading = true;

                    this.newExpression.f_name       = this.newExpression.first_name
                    this.newExpression.m_name       = this.newExpression.middle_name
                    this.newExpression.l_name       = this.newExpression.last_name
                    this.newExpression.phone_number = this.newExpression.phone

                    apiCall({ url: "/api/register", data: this.newExpression, method: "POST" })
                    .then((resp) => {
                        if(resp.status == 409){
                            this.message    = resp.message
                            this.color      = "error";
                            this.loading    = false;
                            this.snackbar   = true;
                        }else{
                            this.message    = "Account Created. We've sent you an activation link via email.";
                            this.color      = "success";
                            this.loading    = false;
                            this.snackbar   = true;

                            this.e1 = 4
                        }                        
                    })
                    .catch((error) => {
                        console.log(error)
                        this.message    = "An error occurred; Please try again.";
                        this.loading    = false;
                        this.snackbar   = true;
                        this.alertType  = "error";
                    });
                }
            }
        },
	
		saveEOI() {
			if (this.$refs.profileForm.validate()) {
				if (this.newExpression.description == null) {
					this.message = "Please add a Company Overview";
					this.color = "error";
					this.loading = false;
					this.snackbar = true;
				} else if (this.newExpression.sectors.length == 0) {
					this.message = "Please add at least one sector";
					this.color = "error";
					this.loading = false;
					this.snackbar = true;
				} else if (this.newExpression.stage_id == null) {
					this.message = "Please fill in what stage your company is currently at";
					this.color = "error";
					this.loading = false;
					this.snackbar = true;
				} else {
					confirm("Are you sure you want to submit your Expression of Interest?") && (this.confirm = true);
					if (this.confirm) {
						this.loading = true;
						apiCall({
							url: "/api/expression",
							data: this.newExpression,
							method: "POST",
						})
							.then((resp) => {
								window.scrollTo(0, 0);

                                if(resp.status == 409){
                                    this.message    = "Expression Interest Updated Successfully";
                                }else{
                                    this.message    = "Expression Interest Submitted Successfully";
                                }
								this.color      = "green";
								this.loading    = false;
								this.snackbar   = true;
								this.confirm    = false;
								this.e1         = 3
							})
							.catch((error) => {
								this.message    = "An Error Occurred";
								this.color      = "error";
								this.loading    = false;
								this.snackbar   = true;
							});
					}
				}
			}
		},
		getFormData() {
			apiCall({
				url: "/api/expression?type=formData",
				method: "GET",
			})
				.then((resp) => {
					this.formData = resp;

					// this.getExpression()
				})
				.catch((error) => {
					this.message = "An Error Occurred; Couldn't Get Form Data";
					this.color = "error";
				});
		},
		getExpression() {
			apiCall({
				url: "/api/expression?type=owner",
				method: "GET",
			})
				.then((resp) => {
					if (resp.code == 200) {
						this.$nextTick(() => {
							this.newExpression.image = resp.expression.image
						});
						this.newExpression.id = resp.expression.id

						if (resp.expression.name != null) {
							this.newExpression.name = resp.expression.name
						}
						if (resp.expression.email != null) {
							this.newExpression.email = resp.expression.email
						}
						if (resp.expression.phone_number != null) {
							this.newExpression.phone_number = resp.expression.phone_number
						}

						this.newExpression.slogan 					= resp.expression.slogan
						this.newExpression.year_established 		= parseInt(resp.expression.year_established)
						this.newExpression.description 			= resp.expression.description
						// this.newExpression.pitch 				= resp.expression.pitch
						this.newExpression.video_pitch_url 		= resp.expression.video_pitch_url
						this.newExpression.physical_address 		= resp.expression.physical_address

						this.newExpression.website_url 			= resp.expression.website_url
						this.newExpression.x_url 					= resp.expression.x_url
						this.newExpression.linkedin_url 			= resp.expression.linkedin_url
						this.newExpression.facebook_url 			= resp.expression.facebook_url
						this.newExpression.youtube_url 			= resp.expression.youtube_url
						this.newExpression.instagram_url 			= resp.expression.instagram_url
						this.newExpression.tiktok_url 				= resp.expression.tiktok_url
						this.newExpression.stage_id 				= resp.expression.step_id
						this.newExpression.organisation_type_id 	= resp.expression.organisation_type_id
						this.newExpression.funding 				= resp.expression.funding
						this.newExpression.cr12 					= resp.expression.cr12
						this.newExpression.registration_cetificate = resp.expression.registration_cetificate

						this.newExpression.c_suite_women			= resp.expression.c_suite_women
						this.newExpression.full_time_employee_count= resp.expression.full_time_employee_count
						this.newExpression.part_time_employee_count= resp.expression.part_time_employee_count
				
						this.newExpression.sectors 				= []
						this.newExpression.client_locations 		= []
						// this.newExpression.client_types 		= []
						this.newExpression.cities 				= []

						for (var x = 0; x < resp.expression.expression_sectors.length; x++) {
							this.newExpression.sectors.push(resp.expression.expression_sectors[x].sector_id)
						}
						for (var x = 0; x < resp.expression.expression_client_locations.length; x++) {
							this.newExpression.client_locations.push(resp.expression.expression_client_locations[x].client_location_id)
						}
						// for (var x = 0; x < resp.expression.expression_client_types.length; x++) {
						// 	this.newExpression.client_types.push(resp.expression.expression_client_types[x].client_type_id)
						// }
						for (var x = 0; x < resp.expression.expression_cities.length; x++) {
							this.newExpression.cities.push(resp.expression.expression_cities[x].city_id)
						}

					}

				})
				.catch((error) => {

				});
		},

	},
	computed: {
		...mapGetters([
			"darkState",
			"getProfile"
		]),
	},
};
</script>
